module.exports = __webpack_public_path__ + "media/images/christian-matrimony-canada-hero-b4862fa2f69d6e5d7e8757290865fb8b.jpg";